import { useMutation } from "@apollo/client/react";
import { CREATE_TEMPLATE } from "../../mutations/invoiceInterpretationTemplates/createTemplate";

export const useCreateTemplate = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [createTemplate, { data, loading, error }] = useMutation(
    CREATE_TEMPLATE,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: ["clientTemplates"],
      awaitRefetchQueries: true,
    },
  );

  return { createTemplate, data, loading, error };
};
